// eslint-disable-next-line no-restricted-imports
import { Controller } from 'react-hook-form-v7';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { COLORS } from '../../../utils/Application_Constants';

const datePickerSlotProps = {
    textField: {
        placeholder: 'mm/dd/yyyy',
        sx: { '& .MuiPickersSectionList-root': { py: '12px' } },
        InputLabelProps: { sx: { fontSize: '14px', fontWeight: '600', lineHeight: '22px' } },
        InputProps: {
            sx: {
                px: '12px',
                fontSize: 12,
                fontWeight: 400,
                lineHeight: '120%',

                '& .MuiIconButton-root': {
                    color: COLORS.LT_JOURNEY,
                },
                '&.Mui-readOnly': {
                    color: COLORS.LT_MIDNIGHT50,
                    '& .MuiIconButton-root': {
                        color: COLORS.LT_JOURNEY25,
                    },
                },
            },
        },
    },
    openPickerButton: { 'aria-label': 'Choose date' },
};

const ConnectedDatePicker = ({ control, name, defaultValue, pickerProps, rules, dateAdapter }) => (
    <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field, fieldState }) => (
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                    {...field}
                    {...pickerProps}
                    data-testid={`${name}-input`}
                    value={field.value} // Explicitly set value for clarity
                    onChange={(newValue) => {
                        const normalizedValue =
                            newValue && dateAdapter ? dateAdapter(newValue) : newValue;
                        field.onChange(normalizedValue);
                    }}
                    slotProps={{
                        ...datePickerSlotProps,
                        ...(pickerProps?.slotProps || {}),
                        textField: {
                            ...datePickerSlotProps?.textField,
                            ...(pickerProps?.slotProps?.textField || {}),
                            helperText: fieldState.error?.message,
                            error: !!fieldState.error,
                            onBlur: (event) => {
                                pickerProps?.slotProps?.textField?.onBlur?.(event);
                                field.onBlur();
                            },
                        },
                    }}
                />
            </LocalizationProvider>
        )}
    />
);

export default ConnectedDatePicker;
